// src/admin/AdminHeader.js
import React, { useContext } from "react";
import { FaBars, FaGlobe, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AdminLanguageContext } from "./context/AdminLanguageContext";

function AdminHeader({ setIsOpen }) {
  const { lang, toggleLanguage } = useContext(AdminLanguageContext);
  const navigate = useNavigate();

  const TEXT = {
    EN: {
      dashboard: "Dashboard",
      welcome: "Welcome, Admin 👋",
      logout: "Logout",
    },
    AR: {
      dashboard: "لوحة التحكم",
      welcome: "مرحباً، المشرف 👋",
      logout: "تسجيل الخروج",
    },
  }[lang];

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/admin/login", { replace: true });
  };

  return (
    <header className="w-full bg-white shadow px-4 py-3 flex items-center justify-between sticky top-0 z-30">
      {/* LEFT */}
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden text-gray-700 text-2xl"
          onClick={() => setIsOpen(true)}
        >
          <FaBars />
        </button>

        <h2 className="text-lg sm:text-xl font-bold text-gray-700">
          {TEXT.dashboard}
        </h2>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-4">
        {/* LANGUAGE TOGGLE */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-2 px-3 py-1 border rounded-full text-sm font-semibold hover:bg-gray-100"
        >
          <FaGlobe />
          {lang}
        </button>

        <div className="hidden sm:block font-semibold text-gray-500">
          {TEXT.welcome}
        </div>

        {/* LOGOUT */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-1 rounded-full text-sm font-semibold bg-red-50 text-red-700 border border-red-200 hover:bg-red-100"
          title={TEXT.logout}
        >
          <FaSignOutAlt />
          <span className="hidden sm:inline">{TEXT.logout}</span>
        </button>
      </div>
    </header>
  );
}

export default AdminHeader;
